import axiosInstance from "shared/axios";
import { PINCODE_LIST_API } from "shared/constants";

  export const pinCodeListing = (param) =>{
    let url = `${PINCODE_LIST_API.listing}`
    return axiosInstance.post(url,param)
}

  export const addNewPincode = (payload) => {
    let url = `${PINCODE_LIST_API.create}`;
    return axiosInstance.post(url, payload);
  };
  export const updatePinCodeList = (payload, pincodeRefNo) => {
    let url = `/api/v2/configurations/pincode/${pincodeRefNo}/update`;
    return axiosInstance.patch(url, payload,{withCredentials: false});
  };
  export const stateDropDwonList = (param) => {
    let fullParam = param ? `${PINCODE_LIST_API.dropDownState}${param}` : `${PINCODE_LIST_API.dropDownState}`;
    return axiosInstance.post(fullParam)
  }
  export const cityDropDwonListApi = (param) => {
    let fullParam = param ? `${PINCODE_LIST_API.dropDownCity}${param}` : `${PINCODE_LIST_API.dropDownCity}`;
    return axiosInstance.post(fullParam)
  }
